export enum Size {
  MOBILE = 'MOBILE',
  TABLET = 'TABLET',
  MONITOR = 'MONITOR',
}

export const SMALL_SCREEN_SIZE = 430;
export const LARGE_SCREEN_SIZE = 820;

export const ADMIN = 'admin';
export const OWNER = 'owner';
export const USER = 'user';

export enum FILTER {
  ALL_FILTER = 'all',
  DAILY_FILTER = 'daily',
  TOMORROW_FILTER = 'tomorrow',
  _7DAYS_FILTER = '7days',
  TODAY_FILTER = 'today',
}

export const PHONE_NUMBER_PATTERN =
  /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/;

export enum UserRole {
  ADMIN = 'admin',
  OWNER = 'owner',
  USER = 'user',
}

export const EMAIL_PATTERN = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
